"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.presentStuff = exports.getIconForClass = exports.iconForClassMap = void 0;
var rdflib_1 = require("rdflib");
var solid_ui_1 = require("solid-ui");
var solid_logic_1 = require("solid-logic");
var iconForClass = solid_ui_1.widgets.iconForClass;
var typeIndex = solid_logic_1.solidLogicSingleton.typeIndex;
var getScopedAppInstances = typeIndex.getScopedAppInstances;
exports.iconForClassMap = {}; // @@ move to buttons in solid-ui
for (var k in iconForClass) {
    var pref = k.split(':')[0];
    var id = k.split(':')[1];
    var theClass = solid_ui_1.ns[pref](id);
    exports.iconForClassMap[theClass.uri] = rdflib_1.uri.join(iconForClass[k], solid_ui_1.icons.iconBase);
}
function getIconForClass(klass) {
    var icon0 = exports.iconForClassMap[klass.uri];
    return icon0 || solid_ui_1.icons.iconBase + 'noun_10636.svg'; //  fall back to black disk
}
exports.getIconForClass = getIconForClass;
function presentStuff(subject) {
    return __awaiter(this, void 0, void 0, function () {
        var scopedItems, stuff;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getScopedAppInstances(null, subject)];
                case 1:
                    scopedItems = _a.sent();
                    console.log('scopedItems', scopedItems);
                    stuff = scopedItems.map(function (item) {
                        var icon = getIconForClass(item.type || solid_ui_1.ns.rdf('Resource')); // eslint-disable-line
                        var href = item.instance.uri;
                        var name = solid_ui_1.utils.label(item.instance);
                        var instance = item.instance;
                        console.log("   href=".concat(href, " name=").concat(name, " icon=").concat(icon));
                        return { href: href, name: name, icon: icon, instance: instance };
                    });
                    return [2 /*return*/, { stuff: stuff }];
            }
        });
    });
}
exports.presentStuff = presentStuff;
//# sourceMappingURL=StuffPresenter.js.map